import Link from "next/link";
import {TextButton} from "@FRAMEWORK/ui/mobile/button";
// import * as style from "@COMPONENTS/hotel/styles/error/errorM";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {useRouter} from "next/router";

const Error = () => {
	const router = useRouter();
	return (
		<></>
		// <style.Wrap>
		// 	<style.Logo>
		// 		<Link href={"#"}>
		// 			<a>
		// 				<Image src={"/include/images/common/logo-yb.svg"} alt="노랑풍선" width="108" height="29" />
		// 			</a>
		// 		</Link>
		// 	</style.Logo>
		// 	<style.Content>
		// 		<style.ConTitle>
		// 			<span>서비스 이용에 불편을 드려 죄송합니다.</span>
		// 		</style.ConTitle>
		// 		<style.Text>
		// 			방문하시려는 웹 페이지의 주소가
		// 			<br />
		// 			잘못 입력되었거나, 변경 또는 삭제되어
		// 			<br />
		// 			요청하신 페이지를 찾을 수 없습니다.
		// 			<br />
		// 			<br />
		// 			새로 고침을 하시거나
		// 			<br />
		// 			페이지 확인 후 다시 접속해 주시기 바랍니다.
		// 		</style.Text>
		// 		<style.ButtonBlock>
		// 			<TextButton
		// 				text="메인 페이지로 이동"
		// 				types="confirm"
		// 				size="default"
		// 				onClick={() => {
		// 					router.push(location.pathname.match(/^\/.+\//).at(0));
		// 					setTimeout(() => router.reload(), 500);
		// 					// location.href = `${publicRuntimeConfig.ENV_MAIN_MOBILE_HOST}`;
		// 				}}
		// 			/>
		// 			<TextButton
		// 				text="이전 페이지로 이동"
		// 				types="basic"
		// 				size="default"
		// 				onClick={() => {
		// 					router.back();
		// 					setTimeout(() => router.reload(), 100);
		// 				}}
		// 			/>
		// 		</style.ButtonBlock>
		// 	</style.Content>
		// </style.Wrap>
	);
};
export default Error;
